import { Component, Input, Output, EventEmitter, Inject, OnInit, AfterViewChecked, AfterViewInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { ToastrService } from "ngx-toastr";

export interface DialogData {
  modalIsActive: boolean
  title: string
  inputName: string;
  inputValue: string
  infoText: string
  successMessage: string
  heightInput: number
  fontSize: number
  padding: string
  heightButton: number
  byDialog: boolean
}

@Component({
  selector: "lex-modal-with-input-to-copy-data",
  templateUrl: "./lex-modal-with-input-to-copy-data.component.html",
  styleUrls: ["./lex-modal-with-input-to-copy-data.component.css"],
})
export class LexModalWithInputToCopyDataComponent {
  @Input() modalIsActive: boolean = false;

  @Input() title: string;

  @Input() inputName: string;

  @Input() inputValue: string;

  @Input() infoText: string;

  @Input() successMessage: string = "Dado copiado";

  @Output() onClosingModal: EventEmitter<boolean> = new EventEmitter();

  @Input() heightInput = 94;

  @Input() fontSize = 40;

  @Input() padding = '0 25px'

  @Input() heightButton = 94

  constructor(private toastr: ToastrService, @Inject(MAT_DIALOG_DATA) public data: DialogData, public dialogRef: MatDialogRef<LexModalWithInputToCopyDataComponent>) {
    setTimeout(() => {
      if (this.data.byDialog) {
        this.title = this.data.title
        this.inputName = this.data.inputName
        this.inputValue = this.data.inputValue
        this.infoText = this.data.infoText
        this.successMessage = this.data.successMessage
        this.heightInput = this.data.heightInput
        this.fontSize = this.data.fontSize
        this.padding = this.data.padding
        this.heightButton = this.data.heightButton
        this.modalIsActive = true
      }
    }, 200)
  }

  handleCloseModal() {
    this.modalIsActive = false;
    this.onClosingModal.emit(false);
    this.dialogRef.close()
  }

  async handleCopyDataToClipboard() {
    const input = document.getElementById(this.inputName) as HTMLInputElement;

    input.select();
    document.execCommand("copy");
    this.toastr.success("", this.successMessage);
  }
}
